import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { createImageURL, createImageAlt } from '../../utils/vehicleImageURL';
import { StyledVehicleBoxImage } from './styles';

class VehicleImage extends Component {
  static propTypes = {
    modelLineCode: PropTypes.string.isRequired,
    size: PropTypes.string,
    imageURL: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired
  }
  static defaultProps = {
    size: 'medium'
  }
  render() {
    // eslint-disable-next-line
    const { imageURL, imageAlt, modelLineCode, size } = this.props;
    return (
      <div>
        <StyledVehicleBoxImage src={imageURL} alt={imageAlt} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  imageURL: createImageURL(state, ownProps.modelLineCode, ownProps.size),
  imageAlt: createImageAlt(state, ownProps.modelLineCode)
});

export default connect(mapStateToProps)(VehicleImage)



/** WEBPACK FOOTER **
 ** ./src/components/VehicleImage/index.js
 **/